import { render, staticRenderFns } from "./CloseStep.vue?vue&type=template&id=6e6cb9ba&"
import script from "./CloseStep.vue?vue&type=script&lang=js&"
export * from "./CloseStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports